"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createImagingProcedures = createImagingProcedures;
const utils_1 = require("../../../events/utils");
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const messages_1 = require("./messages");
const messages = {
    imagingProcedures: {
        id: "dashboard.imaging_procedures",
        defaultMessage: "Képalkotó vizsgálatok"
    },
    date: {
        id: "dashboard.imaging_procedures.date",
        defaultMessage: "Dátum"
    },
    result: {
        id: "dashboard.imaging_procedures.result",
        defaultMessage: "Eredmény"
    },
    chestXray: {
        id: "dashboard.chest_xray",
        defaultMessage: "Mellkas rtg."
    },
    chestCt: {
        id: "dashboard.chest_ct",
        defaultMessage: "Mellkas CT"
    },
    abdominalUltrasound: {
        id: "dashboard.abdominal_ultrasound",
        defaultMessage: "Hasi UH."
    },
    abdominalCt: {
        id: "dashboard.abdominal_ct",
        defaultMessage: "Hasi CT"
    },
    abdominalMri: {
        id: "dashboard.abdominal_mri",
        defaultMessage: "Hasi MRI"
    },
    lumbarSpineXRay: {
        id: "dashboard.lumbar_spine_xray",
        defaultMessage: "2 irányú lumbalis gerinc RTG"
    },
    gastroscopia: {
        id: "dashboard.gastroscopia",
        defaultMessage: "Gastroscopia"
    },
    craniumCt: {
        id: "dashboard.cranium_ct",
        defaultMessage: "Koponya CT"
    },
    craniumMr: {
        id: "dashboard.cranium_mr",
        defaultMessage: "Koponya MR"
    },
    abdominalDopplerUltrasound: {
        id: "dashboard.abdominal_doppler_ultrasound",
        defaultMessage: "Hasi Doppler UH."
    },
    ctAngiography: {
        id: "dashboard.ct_angiography",
        defaultMessage: "CT angiographia"
    },
    angiographyIndirectPortography: {
        id: "dashboard.angiography_indirect_portography",
        defaultMessage: "Angiographia / Indirekt portographia"
    }
};
var ImagingProcedureResult;
(function (ImagingProcedureResult) {
    ImagingProcedureResult["NORMAL"] = "NORMAL";
    ImagingProcedureResult["ABNORMAL"] = "ABNORMAL";
})(ImagingProcedureResult || (ImagingProcedureResult = {}));
const resultMessages = {
    [ImagingProcedureResult.NORMAL]: messages_1.messages.normal,
    [ImagingProcedureResult.ABNORMAL]: messages_1.messages.abnormal
};
const procedures = [
    { label: messages.chestXray, query: queries_1.queries.chestXray },
    { label: messages.chestCt, query: queries_1.queries.chestCt },
    { label: messages.abdominalUltrasound, query: queries_1.queries.abdominalUltrasound },
    { label: messages.abdominalCt, query: queries_1.queries.abdominalCt },
    { label: messages.abdominalMri, query: queries_1.queries.abdominalMri },
    { label: messages.lumbarSpineXRay, query: queries_1.queries.lumbarSpineXRay },
    { label: messages.gastroscopia, query: queries_1.queries.gastroscopia },
    { label: messages.craniumCt, query: queries_1.queries.craniumCt },
    { label: messages.craniumMr, query: queries_1.queries.craniumMr },
    {
        label: messages.abdominalDopplerUltrasound,
        query: queries_1.queries.abdominalDopplerUltrasound
    },
    { label: messages.ctAngiography, query: queries_1.queries.ctAngiography },
    {
        label: messages.angiographyIndirectPortography,
        query: queries_1.queries.angiographyIndirectPortography
    }
];
function createImagingProcedures(intl, options) {
    const tables = createImagingProcedureTables(intl, options);
    const content = (0, shared_1.createSectionContent)(tables);
    return (0, shared_1.createSection)(intl, {
        label: messages.imagingProcedures,
        content
    });
}
function createImagingProcedureTables(intl, { events }) {
    const { formatMessage, formatMessageMap, formatDate } = intl;
    const columns = [
        formatMessage(messages.date),
        formatMessage(messages.result)
    ];
    const tables = [];
    for (const { label, query } of procedures) {
        const relevantEvents = (0, utils_1.findEventsByQuery)(events, query);
        if (relevantEvents.length === 0) {
            continue;
        }
        const sortedEvents = relevantEvents.sort(shared_1.compareByTimestamp);
        const attachments = (0, utils_1.mapEventsToAttachments)(sortedEvents);
        const rows = sortedEvents.map(event => {
            const formattedDate = formatDate(event.timestamp, {
                year: "numeric",
                month: "numeric",
                day: "numeric"
            });
            const resultValue = formatMessageMap(resultMessages, event.value);
            return [formattedDate, resultValue];
        });
        tables.push({
            type: "table",
            label: formatMessage(label),
            attachments,
            columns,
            rows
        });
    }
    return tables;
}
